import { useToast } from "@chakra-ui/react";

export function useErrorToast() {
  const toast = useToast();

  const showErrorToast = (description: string) => {
    toast({
      title: "Erro",
      description: description,
      status: "error",
      isClosable: true,
      duration: 5000
    });
  };

  return showErrorToast;
}
